module.exports = __webpack_public_path__ + "static/media/magneuro31.cf73c1b6.pdf";